import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('sales-completions-comments', storeModule.createStoreModule('sales-completions-comments'))
